import { render } from "./Rondleiding.vue?vue&type=template&id=0f4cb168"
import script from "./Rondleiding.vue?vue&type=script&lang=js"
export * from "./Rondleiding.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__